import { render } from "./SquareRoundBtn.vue?vue&type=template&id=bebcbf36&scoped=true"
import script from "./SquareRoundBtn.vue?vue&type=script&lang=js"
export * from "./SquareRoundBtn.vue?vue&type=script&lang=js"

import "./SquareRoundBtn.vue?vue&type=style&index=0&id=bebcbf36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebcbf36"]])

export default __exports__